export default {
    loading() {
        return this.$store.state.loading
    }
}
